<template>
	<div class="reward-redeem-action">


		<div v-for="(credential, index) in selectedMyPayoutData.reward_data.credentials" :key="index" class=" mb-4">
			<div class="reward-redeem-action__title text-center">{{ credential.label }}</div>
			<div class="d-flex align-center">
				<span class="reward-redeem-action__value">
					{{ credential.value }}
				</span>
				<button icon class="button--secondary rounded-lg reward-redeem-action__copy-btn ml-2 mt-2"
					@click="copyToClipboard(credential.value)">
					<v-icon>mdi-content-copy</v-icon>
				</button>
			</div>
		</div>



		<div v-for="(action, index) in selectedMyPayoutData.reward_data.actions" :key="index">
			<button v-if="action.url" class="button--primary rounded-pill px-5 py-3" @click="openUrl(action.url)">
				<span class="reward-redeem-action__button">{{ action.label }}</span>
			</button>
		</div>



	</div>
</template>



<script setup lang="ts">

import log from 'loglevel';
import { computed } from "vue";
import { PayoutStore } from "@/store/PayoutStore";

const payoutStore = PayoutStore();

const selectedMyPayoutData = computed(() => {
    return payoutStore.SelectedMyPayoutData;
});

const openUrl = (url: string) => {
	window.open(url, '_blank');
};

function copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
        console.log('Copying to clipboard was successful!');
    }, err => {
        log.error('Could not copy text: ', err);
    });
}

</script>